import React, { useState } from 'react';
import { Tabs } from 'antd';
import { useQuery } from 'react-query';
import { Col, Row } from 'reactstrap';
import '../utils/style.css';
import { getAccountsPaiementByMerchantId } from '../../payements/services/paymentApi';
import ReversHistory from '../component/reversHistory';
import PaiementMasse from '../component/addVersement';
import Solde from '../../solde/pages';

const { TabPane } = Tabs;

  const VersementMasse = () => {
  document.title = `Paiement en masse | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;

  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
  const merchandId = currentUser?.user?.id;
  const { data: payoutAccounts, isLoading : isLoadAccount, isError: isErrorAcc, error : errorAcc } = useQuery(
    ["accounts", merchandId],
    () => getAccountsPaiementByMerchantId(merchandId),
    { enabled: !!merchandId }
  );
  const accounts = payoutAccounts?.payoutAccounts || [];

  const [activeTab, setActiveTab] = useState("demande");

  return (
    <div>
      <Row>
        <Col lg={1}></Col>
        <Col lg={10}>
            <div className='title-page mb-2 mt-4'>Paiement en masse</div>
            <div className='verse-description'>
                <span role="img" aria-label="lightbulb">💡</span>
                Transférez de l'argent, individuellement ou en groupe, vers des comptes Mobile Money et portefeuilles électroniques en moins de 5 minutes.
            </div>
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            className="versement-tabs"
          >
            <TabPane tab="Envoyer de l'argent" key="demande">
              <PaiementMasse accounts={accounts} isLoadAccount={isLoadAccount} isErrorAcc={isErrorAcc} errorAcc={errorAcc} />
            </TabPane>
            <TabPane tab="Historique des envoies" key="historique">
              <ReversHistory showButton = {false} showCard = {false}/>
            </TabPane>
          </Tabs>
        </Col>
        <Col lg={1}></Col>
      </Row>
    </div>
  );
};

export default VersementMasse;
